var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _circle, _circle2, _circle3, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _g, _g2, _path141, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 382,
    height: 194,
    viewBox: "0 0 382 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10512_1552)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 382,
    height: 194,
    rx: 24,
    fill: "#0E5A91"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197.613 139.627C116.736 143.733 117.31 196.882 111 227.046V255.682L475.807 270L482.116 63.2459C494.162 0.245981 379.824 -34.0113 336.423 6.54598C291.683 48.355 299.139 134.472 197.613 139.627Z",
    fill: "#628EB3"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M275.919 174.25H256.464V196.668H275.919V174.25Z",
    fill: "#463332"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M275.919 178.965H256.464V185.99H275.919V178.965Z",
    fill: "#463332"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M334.023 69H198.342C194.287 69 191 72.2872 191 76.3421V171.436C191 175.491 194.287 178.778 198.342 178.778H334.023C338.078 178.778 341.365 175.491 341.365 171.436V76.3421C341.365 72.2872 338.078 69 334.023 69Z",
    fill: "url(#paint0_linear_10512_1552)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M191 165.492V171.698C191 175.946 194.28 179.394 198.342 179.394H334.023C338.085 179.394 341.365 175.946 341.365 171.698V165.492H191Z",
    fill: "url(#paint1_linear_10512_1552)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M331.269 71.2656H201.428C197.546 71.2656 194.399 74.4364 194.399 78.3478V154.828C194.399 158.74 197.546 161.91 201.428 161.91H331.269C335.151 161.91 338.298 158.74 338.298 154.828V78.3478C338.298 74.4364 335.151 71.2656 331.269 71.2656Z",
    fill: "url(#paint2_linear_10512_1552)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M194.399 77.2656C194.399 73.9519 197.085 71.2656 200.399 71.2656H332.298C335.611 71.2656 338.298 73.9519 338.298 77.2656V81.4632H194.399V77.2656Z",
    fill: "url(#paint3_linear_10512_1552)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 197.798,
    y: 87.1289,
    width: 13.5967,
    height: 4.53224,
    fill: "#DDC8BA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 212.528,
    y: 87.1289,
    width: 13.5967,
    height: 4.53224,
    fill: "#DDC8BA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 311.104,
    y: 87.1289,
    width: 7.93141,
    height: 3.39918,
    rx: 1.5,
    fill: "#FFB183"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 321.302,
    y: 87.1289,
    width: 13.5967,
    height: 3.39918,
    rx: 1.5,
    fill: "#D4F7E2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 197.798,
    y: 93.9277,
    width: 44.1893,
    height: 7.93141,
    rx: 2,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 197.798,
    y: 104.125,
    width: 44.1893,
    height: 24.9273,
    rx: 2,
    fill: "#FFE1D1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 201.198,
    y: 108.656,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint4_linear_10512_1552)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 201.198,
    y: 118.855,
    width: 35.1248,
    height: 2.26612,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 197.798,
    y: 131.318,
    width: 44.1893,
    height: 27.1934,
    rx: 2,
    fill: "#F2F2F2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 245.387,
    y: 131.318,
    width: 44.1893,
    height: 27.1934,
    rx: 2,
    fill: "#F2F2F2"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 291.842,
    y: 131.318,
    width: 44.1893,
    height: 27.1934,
    rx: 2,
    fill: "#F2F2F2"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 245.387,
    y: 93.9277,
    width: 44.1893,
    height: 7.93141,
    rx: 2,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 292.844,
    y: 93.9277,
    width: 44.1893,
    height: 7.93141,
    rx: 2,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 203.464,
    y: 135.85,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint5_linear_10512_1552)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 203.464,
    y: 146.047,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint6_linear_10512_1552)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 215.927,
    y: 135.85,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint7_linear_10512_1552)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 215.927,
    y: 146.047,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint8_linear_10512_1552)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 228.391,
    y: 135.85,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint9_linear_10512_1552)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 228.391,
    y: 146.047,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint10_linear_10512_1552)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 251.052,
    y: 135.85,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint11_linear_10512_1552)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 251.052,
    y: 146.047,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint12_linear_10512_1552)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 263.516,
    y: 135.85,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint13_linear_10512_1552)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 263.516,
    y: 146.047,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint14_linear_10512_1552)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 275.98,
    y: 135.85,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint15_linear_10512_1552)"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 275.98,
    y: 146.047,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint16_linear_10512_1552)"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 297.508,
    y: 136.984,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint17_linear_10512_1552)"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 297.508,
    y: 147.182,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint18_linear_10512_1552)"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 309.971,
    y: 136.984,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint19_linear_10512_1552)"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 309.971,
    y: 147.182,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint20_linear_10512_1552)"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 322.435,
    y: 136.984,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint21_linear_10512_1552)"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 322.435,
    y: 147.182,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint22_linear_10512_1552)"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 245.387,
    y: 104.125,
    width: 44.1893,
    height: 26.0604,
    rx: 2,
    fill: "#FFE1D1"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 248.786,
    y: 107.523,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint23_linear_10512_1552)"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 248.786,
    y: 115.455,
    width: 35.1248,
    height: 2.26612,
    fill: "white"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 248.786,
    y: 119.988,
    width: 35.1248,
    height: 2.26612,
    fill: "white"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 248.786,
    y: 124.52,
    width: 35.1248,
    height: 2.26612,
    fill: "white"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 292.844,
    y: 104.125,
    width: 44.1893,
    height: 26.0604,
    rx: 2,
    fill: "#FFE1D1"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 296.243,
    y: 107.523,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint24_linear_10512_1552)"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 296.243,
    y: 115.455,
    width: 35.1248,
    height: 2.26612,
    fill: "white"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 296.243,
    y: 119.988,
    width: 35.1248,
    height: 2.26612,
    fill: "white"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 296.243,
    y: 124.52,
    width: 35.1248,
    height: 2.26612,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 314.503,
    cy: 76.9302,
    r: 2.26612,
    fill: "url(#paint25_linear_10512_1552)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 320.169,
    cy: 76.9302,
    r: 2.26612,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.834,
    cy: 76.9302,
    r: 2.26612,
    fill: "url(#paint26_linear_10512_1552)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M336.031 73.4491C334.754 72.1084 332.935 71.2656 330.941 71.2656H201.405C197.534 71.2656 194.399 74.3684 194.399 78.1991V153.145C194.399 154.735 194.941 156.21 195.851 157.378L336.031 73.4491Z",
    fill: "white"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M242.991 193.463H289.374C291.293 193.463 292.858 195.028 292.858 196.948V201.849H239.525V196.948C239.525 195.028 241.091 193.463 243.01 193.463H242.991Z",
    fill: "url(#paint27_linear_10512_1552)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M289.374 193.463H266.378C268.298 193.463 269.863 195.028 269.863 196.948V201.849H292.858V196.948C292.858 195.028 291.293 193.463 289.374 193.463Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M341.365 165.492H191V167.505H341.365V165.492Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M332.681 172.778C332.681 174.362 331.395 175.648 329.811 175.648C328.227 175.648 326.941 174.362 326.941 172.778C326.941 171.194 328.227 169.908 329.811 169.908C331.395 169.908 332.681 171.194 332.681 172.778Z",
    fill: "#463332"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M329.811 174.678C330.861 174.678 331.712 173.827 331.712 172.778C331.712 171.728 330.861 170.877 329.811 170.877C328.761 170.877 327.91 171.728 327.91 172.778C327.91 173.827 328.761 174.678 329.811 174.678Z",
    fill: "url(#paint28_linear_10512_1552)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10512_1552",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 264,
    y: 70,
    width: 140,
    height: 132
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M270.809 70H396.592C400.353 70 403.401 73.0484 403.401 76.8089V194.433C403.401 198.193 400.353 201.242 396.592 201.242H270.809C267.048 201.242 264 198.193 264 194.433V76.8089C264 73.0484 267.048 70 270.809 70Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10512_1552)"
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M370.528 133.693C379.318 139.638 392.413 163.324 394.575 176.978C396.736 190.632 387.676 207.402 387.676 207.402H370.978C370.978 207.402 375.571 188.362 376.112 181.211C376.652 174.06 364.511 161.595 364.511 161.595L370.528 133.693Z",
    fill: "url(#paint29_linear_10512_1552)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M372.185 202.25C372.347 201.529 372.527 200.755 372.707 199.944C372.725 199.854 372.743 199.764 372.761 199.674C373.121 198.035 373.518 196.233 373.896 194.414C373.95 194.198 373.986 193.964 374.04 193.748C374.184 193.081 374.31 192.415 374.436 191.748C374.49 191.478 374.544 191.208 374.599 190.938C374.761 190.091 374.923 189.244 375.067 188.434C375.067 188.398 375.067 188.38 375.067 188.344C375.211 187.515 375.355 186.705 375.481 185.93C375.517 185.714 375.553 185.498 375.589 185.282C375.679 184.723 375.751 184.183 375.823 183.66C375.859 183.462 375.877 183.246 375.913 183.048C376.004 182.382 376.076 181.751 376.112 181.211C376.148 180.706 376.112 180.166 376.022 179.608C376.004 179.463 375.967 179.301 375.949 179.157C375.859 178.689 375.733 178.203 375.571 177.698C375.535 177.608 375.517 177.518 375.481 177.41C375.283 176.834 375.031 176.221 374.761 175.627C374.689 175.465 374.599 175.303 374.526 175.14C374.292 174.654 374.04 174.168 373.77 173.681C373.698 173.537 373.608 173.393 373.536 173.249C373.194 172.655 372.815 172.042 372.437 171.448C372.347 171.304 372.257 171.178 372.167 171.033C370.888 169.106 369.483 167.287 368.24 165.756L372.221 167.413L374.202 157.992C374.689 167.413 382.938 183.606 389.603 183.444C395.926 183.282 394.719 177.86 394.629 177.068C396.718 190.704 387.712 207.365 387.712 207.365H371.014C371.014 207.365 371.518 205.258 372.203 202.214L372.185 202.25Z",
    fill: "#463332"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M283.778 122.003C285.327 121.48 288.317 123.39 288.281 123.354C288.029 125.785 287.56 127.857 286.498 128.884C285.741 128.235 286.209 126.128 285.687 125.767C285.147 125.389 284.75 125.263 284.39 125.389C284.084 125.497 283.201 126.38 282.337 127.407C282.084 127.713 281.814 131.189 280.355 130.685C279.779 130.487 279.581 126.65 280.247 125.767C281.49 124.056 283.021 122.237 283.796 121.985L283.778 122.003Z",
    fill: "url(#paint30_linear_10512_1552)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M283.778 122.003C285.327 121.48 288.317 123.39 288.281 123.354C288.029 125.785 287.56 127.857 286.498 128.884C285.741 128.235 286.209 126.128 285.687 125.767C285.147 125.389 284.75 125.263 284.39 125.389C284.084 125.497 283.201 126.38 282.337 127.407C282.084 127.713 281.814 131.189 280.355 130.685C279.779 130.487 279.581 126.65 280.247 125.767C281.49 124.056 283.021 122.237 283.796 121.985L283.778 122.003Z",
    fill: "#C3694D"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M289.308 165.486C287.597 159.181 286.318 136.971 286.318 136.971L292.622 134.432C292.622 134.432 297.864 151.634 300.62 162.874C300.62 162.874 291.037 171.808 289.326 165.504L289.308 165.486Z",
    fill: "url(#paint31_linear_10512_1552)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M292.622 134.432C291.829 131.028 291.253 124.219 290.334 117.662C289.686 113.069 288.389 110.007 287.831 110.241C286.696 110.727 287.128 113.105 287.669 117.59C287.849 119.049 287.903 121.067 287.921 122.021C287.921 122.021 285.165 120.166 283.688 120.671C282.805 120.959 280.914 123.192 279.707 125.12C279.311 126.11 278.572 128.686 279.004 129.01C279.959 129.713 281.238 127.335 281.616 126.723C282.805 125.588 283.94 124.201 284.3 124.075C285.003 123.823 286.786 125.228 286.93 125.786C287.11 126.435 286.75 127.281 286.083 128.254C284.84 130.073 282.643 131.784 282.445 132.541C283.309 134.558 286.155 136.738 286.75 137.386C289.254 137.783 292.622 134.432 292.622 134.432Z",
    fill: "url(#paint32_linear_10512_1552)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M283.093 133.675C282.247 132.414 281.364 130.559 280.301 128.632C279.13 126.542 277.869 124.939 278.086 124.237C278.5 122.868 280.842 124.381 282.535 126.596C284.318 128.938 285.921 128.325 285.921 128.325C285.921 128.325 286.642 131.334 285.849 133.135C285.057 134.936 283.111 133.675 283.111 133.675H283.093Z",
    fill: "url(#paint33_linear_10512_1552)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M283.093 133.675C283.093 133.657 283.057 133.639 283.057 133.603C282.895 133.369 282.733 133.135 282.607 132.883C281.905 131.694 281.166 130.181 280.301 128.631C280.301 128.631 280.301 128.613 280.301 128.595L279.203 126.74C278.5 125.587 277.96 124.705 278.122 124.236C278.212 123.966 278.356 123.822 278.572 123.75C278.626 124.813 280.446 126.92 281.616 128.866C283.021 131.189 285.021 134.72 288.389 136.611L289.92 144.285L286.876 144.411C286.57 140.088 286.39 136.971 286.39 136.971C285.597 136.269 284.12 135.008 283.165 133.675H283.093Z",
    fill: "#C3694D"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M326.018 133.514C319.84 137.098 304.907 163.775 304.907 163.775L295 137.603L284.066 144.087C284.066 144.087 285.94 185.481 304.259 186.976C318.237 188.111 327.675 165.198 327.675 165.198L326.018 133.532V133.514Z",
    fill: "url(#paint34_linear_10512_1552)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M286.588 142.574C287.561 153.256 292.226 183.067 305.664 183.283C317.588 183.481 321.911 161.722 321.911 161.722L326.18 168.333C323.028 174.565 314.994 187.84 304.259 186.976C285.922 185.481 284.066 144.087 284.066 144.087L286.588 142.592V142.574Z",
    fill: "#463332"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M356.802 125.282C355.919 123.751 343.797 123.156 340.825 126.399C337.852 129.641 346.643 132.343 346.643 132.343C346.643 132.343 358.585 128.344 356.802 125.282Z",
    fill: "#EDD3BE"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M338.249 128.903C338.249 128.903 329.638 130.903 326.486 133.19C323.154 135.604 321.551 144.682 321.533 156.913C321.497 172.782 323.694 193.515 322.451 207.385H373.067C373.067 207.385 372.275 183.77 373.752 164.316C375.463 141.656 373.266 137.081 371.338 134.451C369.411 131.821 358.819 129.876 358.819 129.876L338.249 128.867V128.903Z",
    fill: "url(#paint35_linear_10512_1552)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M355.307 118.942C355.307 118.942 362.296 115.231 363.449 103.829C364.547 92.8951 362.746 90.3012 358.945 88.3198C356.099 86.8247 349.146 92.0485 349.146 92.0485L355.307 118.96V118.942Z",
    fill: "url(#paint36_linear_10512_1552)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M349.795 94.3363C349.795 94.3363 354.766 97.7587 360.188 95.6873C362.62 94.7506 362.566 92.5891 361.845 90.5176C363.575 92.6611 364.223 96.2276 363.449 103.811C362.296 115.213 355.307 118.924 355.307 118.924L349.795 94.8407V94.3183V94.3363Z",
    fill: "#491D17"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M357.595 112.385C357.595 112.385 354.334 122.436 356.676 129.353C357.198 131.082 345.112 130.65 340.518 128.632C340.518 128.632 341.725 127.66 341.905 122.652C341.995 120.364 357.577 112.385 357.577 112.385H357.595Z",
    fill: "url(#paint37_linear_10512_1552)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M340.698 128.451C340.698 128.451 340.176 128.595 338.915 128.793C338.915 128.793 338.915 133.891 346.12 134.558C354.784 135.368 358.945 130 358.945 130L355.541 129.154L340.698 128.451Z",
    fill: "url(#paint38_linear_10512_1552)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M352.659 133.91C346.445 131.695 342.788 128.272 341.401 126.741C341.635 125.84 341.851 124.525 341.923 122.652C342.013 120.364 357.594 112.385 357.594 112.385C357.594 112.385 354.334 122.436 356.676 129.353L358.945 130.001C358.945 130.001 356.892 132.541 352.641 133.892L352.659 133.91Z",
    fill: "#AC6B53"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M357.63 105.126C360.368 104.567 361.827 108.08 360.963 110.259C360.08 112.511 357.558 113.808 355.577 113.484C354.64 112.241 355.847 105.936 357.63 105.126Z",
    fill: "url(#paint39_linear_10512_1552)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M357.811 107.342C359.288 107.162 359.936 109.035 359.414 110.134C358.873 111.269 357.504 111.845 356.46 111.593C356.28 111.359 357.162 107.558 357.811 107.342Z",
    fill: "#E48665"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M357.63 105.126C360.368 104.567 361.827 108.08 360.963 110.259C360.08 112.511 357.558 113.808 355.577 113.484C354.64 112.241 355.847 105.936 357.63 105.126Z",
    fill: "#E48665"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M356.154 103.037C355.937 98.1374 354.046 93.0398 346.463 91.2565C338.015 89.2751 332.647 93.0938 331.62 98.6598C331.278 100.479 331.314 104.64 332.323 111.611C333.295 118.294 335.385 126.327 342.554 126.832C345.508 127.03 353.848 125.553 355.505 113.773C355.505 113.773 356.514 111.017 356.172 103.037H356.154Z",
    fill: "url(#paint40_linear_10512_1552)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M352.191 114.276C353.091 103.666 350.731 95.002 350.731 95.002L354.892 97.3977C355.739 99.1629 356.081 101.126 356.153 103.036C356.514 110.997 355.487 113.771 355.487 113.771C353.812 125.552 345.49 127.047 342.536 126.831C346.48 126.218 351.452 122.976 352.191 114.276Z",
    fill: "#E48665"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M346.336 91.9037C355.487 95.6144 352.839 109.088 354.965 109.268C356.189 109.376 357.126 106.206 357.108 103.648C357.09 100.262 356.424 95.074 353.704 92.7323C352.623 91.7957 347.435 91.4534 346.336 91.9037Z",
    fill: "url(#paint41_linear_10512_1552)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M352.172 97.7944C352.172 97.7944 349.344 90.0308 339.149 91.5799C330.989 92.8048 331.476 101.469 331.476 101.469C328.215 99.5776 326.702 89.7426 330.161 85.4195C333.961 80.6822 331.692 88.3917 339.239 84.5189C348.426 79.8356 358.495 82.1232 359.792 89.1842L352.172 97.7944Z",
    fill: "url(#paint42_linear_10512_1552)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M355.973 96.3358C356.838 98.7675 357.09 101.397 357.108 103.649C357.126 106.207 356.189 109.359 354.965 109.269C353.199 109.125 354.748 99.7582 350.011 94.4805C350.677 94.8768 352.533 96.3358 355.973 96.3538V96.3358Z",
    fill: "#491D17"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M348.39 131.261L346.426 134.63L345.021 131.081L340.933 132.847L338.357 128.848L335.259 129.676C336.736 137.998 339.798 148.302 345.13 153.471C355.019 146.248 359.36 137.188 361.936 130.613C360.999 130.325 359.99 130.109 358.927 129.928L348.39 131.279V131.261Z",
    fill: "#EDD3BE"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M359.486 129.947C359.486 129.947 358.549 135.855 350.065 139.674L348.228 131.262L359.486 129.947Z",
    fill: "#ECD2BD"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M345.057 138.035L348.011 138.125L349.506 151.995C348.101 153.292 346.588 154.535 344.931 155.76C343.994 154.859 343.13 153.814 342.319 152.662L345.057 138.053V138.035Z",
    fill: "url(#paint43_linear_10512_1552)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M343.977 154.733C343.4 154.084 342.842 153.4 342.319 152.661L345.057 138.053L348.012 138.143L348.192 139.854C346.3 140.575 344.283 146.861 343.977 154.751V154.733Z",
    fill: "#822E50"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M350.858 131.73C350.858 131.73 349.038 134.216 346.607 134.036C344.175 133.856 342.608 131.821 342.608 131.821L341.563 133.73C341.563 133.73 343.22 136.288 346.336 136.378C349.471 136.468 351.722 133.82 351.722 133.82L350.858 131.73Z",
    fill: "url(#paint44_linear_10512_1552)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M350.858 131.73C350.858 131.73 349.038 134.216 346.607 134.036C344.175 133.856 342.608 131.821 342.608 131.821L341.563 133.73C341.563 133.73 343.22 136.288 346.336 136.378C349.471 136.468 351.722 133.82 351.722 133.82L350.858 131.73Z",
    fill: "#822E50"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M348.984 133.478C348.48 132.937 344.733 132.901 344.301 133.478C343.85 134.054 344.661 137.801 344.913 138.071C345.165 138.341 347.867 138.395 348.156 138.161C348.444 137.909 349.488 134.036 348.984 133.496V133.478Z",
    fill: "url(#paint45_linear_10512_1552)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M344.301 133.478C344.463 133.262 345.075 133.136 345.814 133.082C345.543 133.46 345.363 133.911 345.363 134.415C345.363 135.712 346.372 136.739 347.633 136.739C348.047 136.739 348.426 136.595 348.768 136.378C348.552 137.261 348.299 138.018 348.173 138.126C347.885 138.378 345.201 138.306 344.931 138.036C344.661 137.765 343.868 134.019 344.319 133.442L344.301 133.478Z",
    fill: "#822E50"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M345.075 131.226L343.256 139.656C343.256 139.656 337.42 135.531 338.176 129.082L345.075 131.226Z",
    fill: "#ECD2BD"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M356.802 125.281C356.802 125.281 354.28 129.784 348.372 131.28L350.371 137.89C354.478 136.413 358.279 132.865 359.486 129.965L356.802 125.299V125.281Z",
    fill: "#FFE6D6"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M345.003 131.083L343.112 137.873C343.112 137.873 337.798 132.29 338.213 128.705L340.734 126.525C340.734 126.525 341.653 129.317 344.985 131.083H345.003Z",
    fill: "#FFE6D6"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M330.161 85.4187C331.206 84.1218 331.782 83.7795 332.232 83.8516C330.107 84.8062 328.972 90.2641 331.17 90.8225C333.115 91.3089 333.529 89.1113 337.258 88.3007C343.382 86.9678 349.201 93.9928 354.821 91.2188C358.657 89.3275 357.667 85.7789 355.721 83.6895C357.865 84.8963 359.378 86.7516 359.828 89.2014C358.603 91.7052 355.901 93.6325 349.543 94.1549C347.561 92.3897 344.301 90.8225 339.167 91.5971C331.008 92.822 331.494 101.486 331.494 101.486C328.234 99.5948 326.721 89.7598 330.179 85.4367L330.161 85.4187Z",
    fill: "#491D17"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M344.427 111.465C345.634 111.465 346.768 110.997 347.633 110.132C348.498 109.286 348.966 108.133 348.966 106.926C348.966 105.719 348.498 104.584 347.633 103.72C346.786 102.855 345.652 102.387 344.427 102.387C341.923 102.387 339.906 104.422 339.887 106.908C339.887 108.115 340.356 109.25 341.22 110.114C342.067 110.979 343.22 111.447 344.427 111.447V111.465ZM344.427 103.089C345.453 103.089 346.408 103.486 347.147 104.224C347.867 104.945 348.263 105.917 348.263 106.944C348.263 107.971 347.867 108.925 347.129 109.664C346.408 110.384 345.435 110.781 344.427 110.781C343.4 110.781 342.445 110.384 341.707 109.646C340.986 108.925 340.59 107.953 340.59 106.926C340.59 104.8 342.319 103.089 344.427 103.089Z",
    fill: "#423333"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M333.818 112.637C333.98 112.637 334.16 112.637 334.34 112.601C336.321 112.277 337.6 110.079 337.222 107.719C336.826 105.36 334.916 103.703 332.917 104.045C330.936 104.369 329.657 106.567 330.035 108.926C330.215 110.061 330.773 111.07 331.566 111.754C332.232 112.331 333.025 112.637 333.818 112.637ZM333.421 104.693C334.88 104.693 336.231 106.026 336.538 107.827C336.862 109.809 335.835 111.646 334.232 111.916C333.475 112.042 332.683 111.79 332.034 111.232C331.368 110.637 330.9 109.791 330.737 108.818C330.413 106.837 331.44 104.999 333.043 104.729C333.169 104.711 333.313 104.693 333.439 104.693H333.421Z",
    fill: "#423333"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M348.588 106.836C348.588 106.836 348.606 106.836 348.624 106.836L357.054 105.863C357.234 105.845 357.36 105.683 357.342 105.485C357.324 105.305 357.162 105.179 356.964 105.197L348.534 106.17C348.354 106.188 348.228 106.35 348.246 106.548C348.264 106.71 348.408 106.836 348.57 106.836H348.588Z",
    fill: "#423333"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M337.096 108.422C337.186 108.422 337.276 108.386 337.348 108.296C338.519 106.8 340.068 107.791 340.122 107.827C340.266 107.917 340.464 107.881 340.554 107.737C340.644 107.593 340.608 107.395 340.464 107.305C339.744 106.836 338.068 106.368 336.843 107.917C336.735 108.061 336.753 108.241 336.897 108.35C336.952 108.386 337.024 108.422 337.096 108.422Z",
    fill: "#423333"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M345.778 155.309L340.086 157.146C336.375 154.625 332.16 150.392 331.836 149.005C331.458 147.383 333.331 144.88 333.331 144.88C333.331 144.88 329.963 144.754 328.954 143.132C328.251 141.98 328.576 135.585 328.846 131.928C330.665 131.118 332.863 130.397 334.682 129.875C336.844 140.935 340.302 149.599 345.76 155.327L345.778 155.309Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M321.569 161.127C327.747 166.999 337.654 168.765 348.57 167.99C359.558 167.197 368.942 164.009 374.202 157.236C374.094 159.38 373.968 161.722 373.77 164.333C372.293 183.787 373.085 207.402 373.085 207.402H322.469C323.604 194.703 321.839 176.312 321.587 161.127H321.569Z",
    fill: "#463332"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M294.333 137.945L284.751 143.727L284.498 140.214L293.469 135.459L294.333 137.945Z",
    fill: "#EDD3BE"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M340.212 158.767C340.05 157.867 339.96 157.308 339.96 157.308L340.41 156.984C347.615 155.489 361.683 141.835 362.782 130.775C364.313 131.154 366.06 131.658 367.61 132.252C367.718 134.54 367.844 142.736 364.223 146.861L359.378 147.203C359.378 147.203 361.215 150.734 360.747 151.652C360.278 152.571 349.489 159.758 340.212 158.749V158.767Z",
    fill: "#463332"
  }))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M361.972 130.199L366.313 131.514C366.313 131.514 367.159 141.421 363.124 146.014L358.441 146.591C358.441 146.591 360.278 149.707 359.828 150.59C359.378 151.472 348.858 158.479 339.96 157.327L345.166 153.526C353.073 147.167 358.873 139.548 361.954 130.199H361.972Z",
    fill: "#665050"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M335.132 129.281L330.665 131.047C330.665 131.047 329.729 141.548 330.593 142.971C331.458 144.376 334.394 144.484 334.394 144.484C334.394 144.484 332.773 146.646 333.097 148.069C333.421 149.474 338.357 154.247 341.815 156.084L345.184 153.545C340.086 148.213 336.988 139.945 335.15 129.299L335.132 129.281Z",
    fill: "#665050"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M345.148 153.526L339.96 157.326C339.96 157.326 342.194 177.05 342.248 188.597C342.302 200.143 341.779 207.294 341.779 207.294H340.644C340.644 207.294 341.293 194.775 341.275 188.759C341.275 182.742 338.897 156.462 338.897 156.462L344.355 152.625L345.148 153.526Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M350.371 182.833C349.177 182.833 348.21 181.865 348.21 180.671C348.21 179.478 349.177 178.51 350.371 178.51C351.565 178.51 352.533 179.478 352.533 180.671C352.533 181.865 351.565 182.833 350.371 182.833Z",
    fill: "#463332"
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M348.804 180.383C348.804 181.41 349.633 182.256 350.678 182.256C351.722 182.256 352.551 181.428 352.551 180.383C352.551 179.338 351.722 178.51 350.678 178.51C349.633 178.51 348.804 179.338 348.804 180.383Z",
    fill: "#665050"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M350.641 196.973C349.448 196.973 348.48 196.006 348.48 194.812C348.48 193.618 349.448 192.65 350.641 192.65C351.835 192.65 352.803 193.618 352.803 194.812C352.803 196.006 351.835 196.973 350.641 196.973Z",
    fill: "#463332"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M349.056 194.524C349.056 195.55 349.885 196.397 350.93 196.397C351.974 196.397 352.803 195.568 352.803 194.524C352.803 193.479 351.974 192.65 350.93 192.65C349.885 192.65 349.056 193.479 349.056 194.524Z",
    fill: "#665050"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M369.393 169.881L354.821 169.917L354.766 160.622L369.339 160.586L369.393 169.881Z",
    fill: "#463332"
  }))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M368.204 168.674L354.694 168.728L354.658 160.677L368.15 160.641L368.204 168.674Z",
    fill: "#FFE6D6"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M363.485 158.713L359.306 158.731L359.324 160.658L363.485 160.64V158.713Z",
    fill: "#847070"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M367.321 167.557H362.692L362.656 161.721L367.285 161.703L367.321 167.557Z",
    fill: "#DDC4B6"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M361.899 165.035L355.595 165.053V163.756L361.899 163.738V165.035Z",
    fill: "#DDC4B6"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M361.899 162.964L355.595 162.982L355.577 161.739L361.881 161.721L361.899 162.964Z",
    fill: "#DDC4B6"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M361.918 166.422L355.613 166.44L355.595 165.774L361.9 165.756L361.918 166.422Z",
    fill: "#DDC4B6"
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M224.17 242.376H171.906C148.847 230.525 143.843 151.544 174.13 144.58C204.418 137.615 208.924 179.081 218.903 183.09C227.067 186.367 237.163 186.63 239.943 196.785C242.723 206.968 241.318 231.783 224.141 242.376H224.17Z",
    fill: "url(#paint46_linear_10512_1552)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M174.277 144.58C174.277 144.58 174.365 144.58 174.423 144.551C165.79 153.652 160.406 166.586 160.406 180.925C160.406 208.432 180.217 230.73 204.652 230.73C219.81 230.73 233.212 222.156 241.172 209.046C240.645 220.517 236.373 234.944 224.316 242.377H172.053C148.994 230.525 143.785 151.779 174.277 144.58Z",
    fill: "#AA2424"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M186.567 147.594C206.554 147.594 209.977 179.49 218.932 183.09C223.38 184.875 228.413 185.753 232.51 187.83C232.451 188.825 232.276 189.615 231.925 190.171C226.657 198.775 227.213 205.739 227.213 205.739H184.899C175.096 205.739 168.629 191.927 168.805 177.764C168.98 162.869 174.716 147.594 186.596 147.594H186.567Z",
    fill: "#AA2424"
  }))), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M181.095 127.431C181.095 135.596 177.203 142.385 178.871 149.349C180.07 154.382 185.806 155.172 185.806 155.172C185.806 155.172 208.016 157.396 209.275 148.091C210.533 138.785 204.593 134.484 204.037 126.992C203.481 119.501 181.095 122.895 181.095 127.46V127.431Z",
    fill: "url(#paint47_linear_10512_1552)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M181.095 127.431C181.095 135.596 177.203 142.385 178.871 149.349C180.07 154.382 185.806 155.172 185.806 155.172C185.806 155.172 208.016 157.396 209.275 148.091C210.533 138.785 204.593 134.484 204.037 126.992C203.481 119.501 181.095 122.895 181.095 127.46V127.431Z",
    fill: "#491D17"
  }))), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M230.198 189.879C228.237 189.236 211.996 186.895 211.996 186.895L207.9 188.797L211.119 205.798H228.559L230.198 189.909V189.879Z",
    fill: "url(#paint48_linear_10512_1552)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M238.216 200.677C242.079 215.426 248.868 238.221 248.868 238.221C246.761 238.924 244.566 239.304 242.108 238.221C242.108 238.221 235.729 227.453 229.7 212.031C227.008 205.183 222.794 194.444 226.92 190.669C229.759 188.065 235.641 190.903 238.216 200.677Z",
    fill: "url(#paint49_linear_10512_1552)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M207.988 189.294L208.397 188.533L211.967 186.895C211.967 186.895 226.891 189.031 229.847 189.792C232.042 190.084 234.588 192.103 236.519 196.083C235.495 194.913 233.856 192.981 231.749 193.684C227.652 195.059 229.291 207.993 233.476 217.796C237.163 226.487 244.625 236.642 246.293 238.836C244.976 239.012 243.571 238.895 242.108 238.222C242.108 238.222 235.729 227.453 229.701 212.031C228.969 210.159 228.12 208.022 227.36 205.769H213.138L210.007 200.004L207.958 189.294H207.988Z",
    fill: "#334B72"
  }))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M180.656 187.888H203.569L203.51 187.215C203.51 187.215 216.562 189 218.464 190.346L211.997 205.768H184.841C179.837 201.934 178.929 193.389 180.627 187.888H180.656Z",
    fill: "url(#paint50_linear_10512_1552)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M223.584 200.822C224.55 217.97 227.008 238.22 227.008 238.22C224.872 239.186 222.326 239.332 220.248 238.22C220.248 238.22 215.391 227.451 212.611 211.942C211.235 204.246 209.275 194.94 213.723 191.077C217.293 187.976 223.028 190.609 223.584 200.822Z",
    fill: "url(#paint51_linear_10512_1552)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M180.656 187.888H203.568L203.51 187.215C203.51 187.215 214.308 188.707 217.702 189.966C220.512 190.58 223.204 194.004 223.584 200.822C223.672 202.402 223.76 204.012 223.877 205.65V205.738C223.175 199.213 223.175 193.302 216.766 193.097C207.87 192.833 196.897 194.852 196.897 198.481C196.897 202.11 212.464 201.583 214.132 202.958C215.771 204.334 212.962 222.389 223.497 238.981C222.385 238.981 221.273 238.747 220.248 238.22C220.248 238.22 215.391 227.451 212.611 211.942C212.26 209.952 211.85 207.845 211.557 205.768H184.899C179.895 201.934 178.988 193.389 180.685 187.888H180.656Z",
    fill: "#334B72"
  }))), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M223.906 163.689C225.311 160.733 227.184 150.93 227.623 149.467C228.15 147.594 224.316 148.033 224.316 148.033C224.053 149.496 220.951 156.139 218.61 161.406C218.61 161.406 222.531 166.644 223.936 163.689H223.906Z",
    fill: "url(#paint52_linear_10512_1552)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M224.287 148.033C224.784 145.721 226.394 141.917 227.974 141.8C228.91 141.741 230.139 144.814 229.817 145.633C229.174 147.33 228.032 148.472 227.681 149.32C227.33 150.198 224.287 148.033 224.287 148.033Z",
    fill: "url(#paint53_linear_10512_1552)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M195.316 145.984C200.964 159.27 208.163 175.072 215.508 176.242C220.336 177.003 226.277 173.696 227.623 153.3L222.092 148.881L215.947 165.122C213.547 164.83 211.323 150.169 206.758 145.545C204.739 143.497 195.316 145.984 195.316 145.984Z",
    fill: "url(#paint54_linear_10512_1552)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M203.773 148.881C207.226 166.468 213.635 172.526 216.269 172.614C220.921 172.76 225.369 169.6 227.623 153.3C226.277 173.696 220.336 177.003 215.508 176.242C208.163 175.072 200.964 159.27 195.316 145.984C195.316 145.984 203.071 149.057 203.773 148.881Z",
    fill: "#A0335D"
  }))), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M199.589 110.225C199.589 110.225 201.813 108.791 204.593 110.957C208.397 113.912 206.641 118.39 207.168 121.55L200.877 114.732L199.589 110.196V110.225Z",
    fill: "url(#paint55_linear_10512_1552)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M200.877 114.759L207.168 121.578C206.788 119.383 207.519 116.544 206.759 114.057C206.29 114.408 205.617 114.379 204.3 113.501C202.925 112.565 201.784 111.102 201.784 111.102L200.408 113.121L200.877 114.789V114.759Z",
    fill: "#491D17"
  }))), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M180.392 188.678C183.67 178.787 189.318 176.3 188.849 169.423C188.498 164.331 181.504 157.894 183.758 148.705C185.484 141.711 192.156 141.916 198.009 141.74C200.35 141.682 202.72 142.238 204.681 143.526C209.041 146.423 212.523 155.523 211.411 159.474C210.27 163.541 207.636 163.775 207.636 169.833C207.636 174.895 210.124 179.841 211.996 187.098C212.318 189.849 190.986 194.589 180.392 188.678Z",
    fill: "url(#paint56_linear_10512_1552)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M188.85 169.423C188.499 164.331 181.505 157.893 183.758 148.705C184.138 147.212 184.724 146.071 185.485 145.164C185.104 148.471 185.777 151.982 187.621 155.113C192.8 163.834 208.193 166.965 211.558 158.362C211.529 158.771 211.47 159.152 211.382 159.503C210.241 163.57 207.607 163.805 207.607 169.862C207.607 174.924 210.095 179.87 211.968 187.127C212.289 189.878 190.957 194.618 180.364 188.707C183.641 178.816 189.289 176.329 188.821 169.452L188.85 169.423Z",
    fill: "#A0335D"
  }))), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M190.927 142.267L189.727 142.56C190.839 145.72 195.024 150.783 200.525 150.08C205.002 149.524 204.183 145.223 202.895 142.56L201.403 141.945L190.927 142.238V142.267Z",
    fill: "url(#paint57_linear_10512_1552)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M191.688 128.396C192.302 130.972 192.507 133.108 192.712 136.122C193.005 140.365 190.781 142.443 190.781 142.443C193.502 143.145 198.506 143.438 201.432 141.974C201.432 141.974 199.179 141.418 200.057 135.624C200.642 131.645 191.717 128.396 191.717 128.396H191.688Z",
    fill: "url(#paint58_linear_10512_1552)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M195.521 149.145C193.414 148.062 191.747 146.248 190.722 144.55C190.371 143.965 190.108 143.438 189.903 142.941C189.903 142.941 189.815 142.707 189.757 142.59L190.956 142.297C190.956 142.297 191.22 141.975 191.395 141.741C191.395 141.741 191.395 141.741 191.395 141.712C191.981 140.805 192.8 139.137 192.712 136.649C192.712 136.503 192.712 136.328 192.712 136.181C192.712 136.035 192.712 135.918 192.712 135.801C192.566 133.899 192.42 132.318 192.156 130.738L199.911 134.425C200.057 134.835 200.116 135.274 200.057 135.684C199.209 141.507 201.433 142.034 201.433 142.034L201.754 142.18C200.935 143.643 198.799 147.038 195.521 149.203V149.145Z",
    fill: "#AC6B53"
  }))), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M192.068 133.607C195.667 138.728 202.281 139.46 203.247 139.167C204.212 138.874 209.772 132.378 207.548 125.15C207.285 124.184 207.051 119.239 205.792 117.161C202.691 112.04 198.36 111.982 194.234 113.445C187.737 115.757 187.532 121.668 189.698 128.105C189.698 128.105 190.517 131.412 192.068 133.607Z",
    fill: "url(#paint59_linear_10512_1552)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M191.746 123.422L189.259 126.582C189.405 127.08 189.522 127.606 189.698 128.133C189.698 128.133 190.517 131.44 192.068 133.635C195.668 138.756 202.281 139.487 203.247 139.195C192.127 137.966 191.746 123.422 191.746 123.422Z",
    fill: "#E38565"
  }))), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M189.347 126.437C187.386 126.203 186.479 128.72 187.182 130.183C187.913 131.704 189.903 132.465 191.278 132.143C191.893 131.236 190.635 126.905 189.347 126.437Z",
    fill: "url(#paint60_linear_10512_1552)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M189.347 126.437C187.386 126.203 186.479 128.72 187.182 130.183C187.913 131.704 189.903 132.495 191.278 132.173C191.893 131.266 190.635 126.905 189.318 126.437H189.347Z",
    fill: "#E38565"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M189.288 127.988C188.235 127.93 187.855 129.276 188.264 130.007C188.703 130.768 189.698 131.09 190.43 130.885C190.547 130.71 189.932 129.802 189.288 127.988Z",
    fill: "#AC6B53"
  }))), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M191.424 125.646C191.366 127.168 191.746 128.485 190.605 128.748C189.464 128.982 188.79 126.407 188.79 126.407L191.424 125.676V125.646Z",
    fill: "url(#paint61_linear_10512_1552)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M202.369 112.654C202.632 116.077 197.482 117.892 194.966 119.618C191.074 122.281 191.425 126.758 191.425 126.758L188.937 126.349C188.937 126.349 182.646 127.9 181.095 127.461C180.129 117.687 182.88 111.454 191.542 108.732C198.828 106.45 202.164 109.991 202.369 112.683V112.654Z",
    fill: "url(#paint62_linear_10512_1552)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M228.854 148.502C228.999 148.734 229.086 148.734 229.028 148.502H228.854Z",
    fill: "#7E8082"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M228.823 148.501C228.296 148.033 226.833 145.429 225.224 142.151C223.409 138.435 221.975 135.392 222.473 135.157C222.97 134.923 224.463 137.908 226.277 141.654C227.887 144.961 228.969 147.828 229.028 148.531H228.823V148.501Z",
    fill: "url(#paint63_linear_10512_1552)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M224.235 140.066L225.287 139.553L225.634 140.263L224.582 140.776L224.235 140.066Z",
    fill: "url(#paint64_linear_10512_1552)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M228.501 147.448C228.179 147.067 226.833 144.317 225.662 141.888C224.316 139.137 222.882 136.24 223.087 136.123C223.292 136.035 224.785 138.903 226.131 141.654C227.301 144.083 228.501 146.921 228.589 147.389H228.501V147.448Z",
    fill: "#A7AAAF"
  }))), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M224.209 140.038L224.656 139.82L225.002 140.53L224.555 140.749L224.209 140.038Z",
    fill: "#A69B9B"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M228.501 141.742C228.823 142.21 228.354 142.591 227.857 143.029C227.359 143.468 226.833 143.849 226.481 143.498C226.101 143.117 226.657 142.386 227.213 141.917C227.652 141.537 228.149 141.244 228.501 141.742Z",
    fill: "#FFB182"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M229.817 143.264C230.169 143.673 229.7 144.288 229.144 144.932C228.588 145.605 227.857 146.336 227.476 145.956C227.125 145.575 227.74 144.727 228.354 144.025C228.881 143.41 229.437 142.854 229.817 143.264Z",
    fill: "#FFB182"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M230.051 144.433C230.315 144.755 230.022 145.34 229.613 145.867C229.174 146.423 228.588 146.95 228.237 146.745C227.857 146.511 228.383 145.75 228.852 145.165C229.232 144.667 229.73 144.023 230.081 144.462L230.051 144.433Z",
    fill: "#FFB182"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M229.32 142.473C229.642 142.941 229.233 143.38 228.735 143.936C228.179 144.55 227.565 145.077 227.096 144.755C226.599 144.433 227.272 143.526 227.916 142.912C228.443 142.385 228.999 141.975 229.35 142.443L229.32 142.473Z",
    fill: "#FFB182"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M205.002 178.875C206.202 178.934 209.362 179.168 210.884 179.372C212.406 179.577 215.186 180.923 215.098 181.538C215.01 182.182 212.933 180.719 211.235 180.455C209.538 180.192 205.002 178.875 205.002 178.875Z",
    fill: "url(#paint65_linear_10512_1552)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M203.89 182.095C205.002 182.768 206.67 183.119 208.748 183.47C211.908 184.026 212.581 185.138 212.991 184.494C213.371 183.909 209.714 182.826 209.86 182.592C209.977 182.358 211.382 182.768 212.464 183.207C213.84 183.734 215.156 184.465 215.361 184.026C215.566 183.587 214.63 183.207 213.137 182.475C211.733 181.773 210.562 181.568 210.562 181.305C210.562 181.041 212.172 181.744 213.488 182.241C214.6 182.651 215.8 183.675 216.151 183.178C216.386 182.826 215.01 181.978 213.606 181.275C211.177 180.046 209.245 179.373 206.992 179.052C206.026 178.905 205.031 178.876 205.031 178.876C205.031 178.876 205.031 178.525 204.3 180.076C203.539 181.627 203.919 182.095 203.919 182.095H203.89Z",
    fill: "url(#paint66_linear_10512_1552)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M205.003 178.876C203.744 178.759 200.086 177.705 200.086 177.705L198.565 181.451C198.565 181.451 202.574 181.743 203.861 182.065C205.149 182.387 204.973 178.846 204.973 178.846L205.003 178.876Z",
    fill: "url(#paint67_linear_10512_1552)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M200.115 177.705C200.115 177.705 203.042 178.554 204.563 178.788C204.417 179.49 204.183 181.48 205.968 182.329C207.841 183.236 209.099 183.382 210.065 183.733C209.684 183.645 209.275 183.528 208.806 183.441C206.729 183.06 205.061 182.738 203.949 182.065C202.661 181.743 198.652 181.451 198.652 181.451L200.174 177.705H200.115Z",
    fill: "#C4694D"
  }))), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M224.111 147.857C223.936 146.247 224.258 144.726 224.609 143.672C224.843 142.97 225.399 141.126 225.867 141.214C226.599 141.36 226.16 143.028 225.984 143.76C225.721 144.843 226.686 145.545 226.774 146.452C226.979 149.115 224.345 149.905 224.141 147.857H224.111Z",
    fill: "#FFB182"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M186.391 144.726C182.616 144.55 174.247 170.067 176.998 175.481C180.158 181.685 197.628 183.118 202.106 183.177C202.106 183.177 204.681 180.221 202.749 176.271C202.749 176.271 189.171 171.326 187.767 169.833C186.362 168.341 197.131 145.194 186.421 144.726H186.391Z",
    fill: "url(#paint68_linear_10512_1552)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M237.923 190.639V189.147C237.923 189.147 235.904 187.42 231.222 187.45C226.54 187.45 220.131 187.479 215.683 187.508C211.265 187.508 209.07 188.883 209.07 188.883V190.698L237.923 190.639Z",
    fill: "#CEB6AA"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M220.775 185.255C226.277 185.109 231.895 185.255 236.899 185.635C230.461 185.635 226.218 186.718 224.053 189.381L207.899 189.44C210.884 185.665 220.775 185.255 220.775 185.255Z",
    fill: "#EDD8CA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M212.962 189.439L213.489 186.396C213.957 186.279 214.455 186.133 214.923 186.045C216.006 186.425 217.761 186.894 220.044 187.069C224.082 187.391 228.706 186.572 228.706 186.572C226.657 187.186 225.106 188.093 224.053 189.41H212.962V189.439Z",
    fill: "#CEB6AA"
  }))), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M194.731 189.497L193.151 189.409V188.912C193.151 188.912 195.316 187.537 199.764 187.537C202.749 187.537 206.641 187.537 210.299 187.507C211.499 187.098 213.576 186.6 216.649 186.688C221.945 186.834 223.643 189.38 223.643 189.38L222.004 189.322V190.697L193.18 190.755V189.673L194.76 189.526L194.731 189.497Z",
    fill: "#CEB6AA"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M194.731 189.497L193.092 189.41V188.912L209.626 188.854V190.697L193.092 190.726V189.644L194.731 189.497Z",
    fill: "#B29B93"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M238.099 190.639V189.147C238.099 189.147 236.08 187.42 231.398 187.45C226.715 187.45 224.082 189.352 224.082 189.352C224.082 189.352 220.307 187.479 215.888 187.508C211.469 187.508 209.275 188.883 209.275 188.883V190.698L238.128 190.639H238.099Z",
    fill: "#FAE7DC"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M208.796 190.671L239.346 190.58L239.349 191.604L208.799 191.695L208.796 190.671Z",
    fill: "url(#paint69_linear_10512_1552)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M191.648 190.721L208.855 190.67L208.858 191.694L191.651 191.745L191.648 190.721Z",
    fill: "url(#paint70_linear_10512_1552)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M224.17 189.499C227.535 185.314 236.811 185.958 236.899 185.958V185.665C236.519 185.636 227.418 185.022 223.965 189.323L224.199 189.499H224.17Z",
    fill: "#FAE7DC"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M222.999 190.61H225.106C225.106 190.61 224.55 189.557 224.053 189.557C223.555 189.557 222.999 190.61 222.999 190.61Z",
    fill: "url(#paint71_linear_10512_1552)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M201.14 185.927C201.14 185.927 202.632 186.103 204.505 186.951L219.722 187.625L223.467 188.824C223.467 188.824 221.156 185.84 213.108 185.313C205.91 184.845 201.111 185.927 201.111 185.927H201.14Z",
    fill: "#CEB6AA"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M209.275 187.918L193.122 187.713C193.122 187.713 195.726 187.04 200.145 186.747C204.563 186.455 215.069 186.045 219.049 187.099C219.049 187.099 214.015 186.338 209.275 187.947V187.918Z",
    fill: "#EDD8CA"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M210.094 185.899L193.941 185.782C193.941 185.782 196.546 185.079 200.964 184.728C204.593 184.435 216.122 183.88 221.243 186.981C221.243 186.981 215.625 184.816 210.065 185.899H210.094Z",
    fill: "#EDD8CA"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M223.848 189.499L224.023 189.265C218.375 184.876 209.772 187.451 209.275 187.626L193.092 187.685V187.977L209.333 187.919C209.333 187.919 218.171 185.11 223.848 189.499Z",
    fill: "#FAE7DC"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M223.818 189.468L224.052 189.293C220.307 184.142 210.211 185.723 210.094 185.723L193.912 185.781V186.074L210.094 186.015C210.094 186.015 220.16 184.435 223.789 189.468H223.818Z",
    fill: "#FAE7DC"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M221.975 189.293C221.975 189.293 221.331 188.972 220.278 188.65C219.224 188.357 217.79 188.094 216.327 188.035C213.401 188.035 210.621 188.942 210.621 188.942C210.621 188.942 213.459 188.181 216.327 188.328C217.761 188.328 219.195 188.474 220.248 188.737C221.302 188.972 221.975 189.293 221.975 189.293Z",
    fill: "#D8C0B6"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M221.127 189.763C221.127 189.763 219.371 189.324 217.586 189.207C215.771 189.207 213.986 189.441 213.986 189.441C213.986 189.441 215.771 189.353 217.556 189.5C219.342 189.5 221.127 189.763 221.127 189.763Z",
    fill: "#D8C0B6"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M225.516 189.323C225.516 189.323 226.218 189.031 227.33 188.767C228.442 188.504 229.935 188.299 231.456 188.328C234.5 188.153 237.426 189.206 237.426 189.206C237.426 189.206 234.558 188.006 231.456 188.036C229.935 188.094 228.413 188.358 227.301 188.679C226.189 188.972 225.516 189.323 225.516 189.323Z",
    fill: "#D8C0B6"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M235.114 189.967C235.114 189.967 232.949 189.47 230.725 189.499C228.501 189.587 226.365 190.172 226.365 190.172C226.365 190.172 228.53 189.733 230.725 189.763C232.92 189.616 235.114 189.938 235.114 189.938V189.967Z",
    fill: "#D8C0B6"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M191.648 190.721L208.855 190.67L208.858 191.694L191.651 191.745L191.648 190.721Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M178.549 173.666C181.592 179.636 197.95 181.187 203.101 181.333C202.691 182.474 202.106 183.147 202.106 183.147C197.658 183.089 180.159 181.655 176.998 175.451C174.482 170.476 181.358 148.412 185.426 145.105C183.846 147.3 176.003 168.633 178.52 173.637L178.549 173.666Z",
    fill: "#A0335D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M183.173 114.644C182.324 116.634 182.412 119.238 185.748 119.999C191.454 121.316 200.438 116.37 200.994 112.303C201.199 110.752 200.877 109.698 199.765 108.908C201.433 109.845 202.281 111.366 202.398 112.654C202.662 116.078 197.511 117.892 194.995 119.618C194.234 120.145 193.561 120.789 193.005 121.55C192.069 122.837 191.571 124.505 191.454 125.822C191.454 127.256 191.717 128.514 190.635 128.719C189.493 128.953 188.82 126.378 188.82 126.378L188.996 126.32C188.791 126.378 182.997 127.783 181.271 127.461C181.212 127.285 181.153 127.08 181.095 126.876C180.656 121.813 181.271 117.746 183.202 114.644H183.173Z",
    fill: "#491D17"
  }))), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M24.644 75L31.812 55.4H35.844L43.012 75H39.204L37.636 70.464H29.992L28.396 75H24.644ZM30.972 67.664H36.656L33.8 59.516L30.972 67.664ZM51.2926 75.336C49.8739 75.336 48.6232 75.028 47.5406 74.412C46.4579 73.796 45.5992 72.9373 44.9646 71.836C44.3486 70.7347 44.0406 69.4747 44.0406 68.056C44.0406 66.6373 44.3486 65.3773 44.9646 64.276C45.5992 63.1747 46.4579 62.316 47.5406 61.7C48.6232 61.084 49.8739 60.776 51.2926 60.776C53.0659 60.776 54.5592 61.2427 55.7726 62.176C56.9859 63.0907 57.7606 64.36 58.0966 65.984H54.3166C54.1299 65.312 53.7566 64.7893 53.1966 64.416C52.6552 64.024 52.0112 63.828 51.2646 63.828C50.2752 63.828 49.4352 64.2013 48.7446 64.948C48.0539 65.6947 47.7086 66.7307 47.7086 68.056C47.7086 69.3813 48.0539 70.4173 48.7446 71.164C49.4352 71.9107 50.2752 72.284 51.2646 72.284C52.0112 72.284 52.6552 72.0973 53.1966 71.724C53.7566 71.3507 54.1299 70.8187 54.3166 70.128H58.0966C57.7606 71.696 56.9859 72.956 55.7726 73.908C54.5592 74.86 53.0659 75.336 51.2926 75.336ZM65.7576 75.336C64.563 75.336 63.583 75.1493 62.8176 74.776C62.0523 74.384 61.483 73.8707 61.1096 73.236C60.7363 72.6013 60.5496 71.9013 60.5496 71.136C60.5496 69.848 61.0536 68.8027 62.0616 68C63.0696 67.1973 64.5816 66.796 66.5976 66.796H70.1256V66.46C70.1256 65.508 69.855 64.808 69.3136 64.36C68.7723 63.912 68.1003 63.688 67.2976 63.688C66.5696 63.688 65.935 63.8653 65.3936 64.22C64.8523 64.556 64.5163 65.06 64.3856 65.732H60.8856C60.979 64.724 61.315 63.8467 61.8936 63.1C62.491 62.3533 63.2563 61.784 64.1896 61.392C65.123 60.9813 66.1683 60.776 67.3256 60.776C69.3043 60.776 70.863 61.2707 72.0016 62.26C73.1403 63.2493 73.7096 64.6493 73.7096 66.46V75H70.6576L70.3216 72.76C69.911 73.5067 69.3323 74.1227 68.5856 74.608C67.8576 75.0933 66.915 75.336 65.7576 75.336ZM66.5696 72.536C67.5963 72.536 68.3896 72.2 68.9496 71.528C69.5283 70.856 69.8923 70.0253 70.0416 69.036H66.9896C66.0376 69.036 65.3563 69.2133 64.9456 69.568C64.535 69.904 64.3296 70.324 64.3296 70.828C64.3296 71.3693 64.535 71.7893 64.9456 72.088C65.3563 72.3867 65.8976 72.536 66.5696 72.536ZM83.2058 75.336C81.8991 75.336 80.7324 75.0187 79.7058 74.384C78.6791 73.7493 77.8671 72.8813 77.2698 71.78C76.6724 70.6787 76.3738 69.428 76.3738 68.028C76.3738 66.628 76.6724 65.3867 77.2698 64.304C77.8671 63.2027 78.6791 62.344 79.7058 61.728C80.7324 61.0933 81.8991 60.776 83.2058 60.776C84.2511 60.776 85.1658 60.972 85.9498 61.364C86.7338 61.756 87.3684 62.3067 87.8538 63.016V54.84H91.4378V75H88.2458L87.8538 73.012C87.4058 73.628 86.8084 74.1693 86.0618 74.636C85.3338 75.1027 84.3818 75.336 83.2058 75.336ZM83.9618 72.2C85.1191 72.2 86.0618 71.8173 86.7898 71.052C87.5364 70.268 87.9098 69.2693 87.9098 68.056C87.9098 66.8427 87.5364 65.8533 86.7898 65.088C86.0618 64.304 85.1191 63.912 83.9618 63.912C82.8231 63.912 81.8804 64.2947 81.1338 65.06C80.3871 65.8253 80.0138 66.8147 80.0138 68.028C80.0138 69.2413 80.3871 70.24 81.1338 71.024C81.8804 71.808 82.8231 72.2 83.9618 72.2ZM101.527 75.336C100.127 75.336 98.8861 75.0373 97.8034 74.44C96.7207 73.8427 95.8714 73.0027 95.2554 71.92C94.6394 70.8373 94.3314 69.5867 94.3314 68.168C94.3314 66.7307 94.6301 65.452 95.2274 64.332C95.8434 63.212 96.6834 62.344 97.7474 61.728C98.8301 61.0933 100.099 60.776 101.555 60.776C102.918 60.776 104.122 61.0747 105.167 61.672C106.213 62.2693 107.025 63.0907 107.603 64.136C108.201 65.1627 108.499 66.3107 108.499 67.58C108.499 67.7853 108.49 68 108.471 68.224C108.471 68.448 108.462 68.6813 108.443 68.924H97.8874C97.9621 70.0067 98.3354 70.856 99.0074 71.472C99.6981 72.088 100.529 72.396 101.499 72.396C102.227 72.396 102.834 72.2373 103.319 71.92C103.823 71.584 104.197 71.1547 104.439 70.632H108.079C107.818 71.5093 107.379 72.312 106.763 73.04C106.166 73.7493 105.419 74.3093 104.523 74.72C103.646 75.1307 102.647 75.336 101.527 75.336ZM101.555 63.688C100.678 63.688 99.9034 63.94 99.2314 64.444C98.5594 64.9293 98.1301 65.676 97.9434 66.684H104.859C104.803 65.7693 104.467 65.0413 103.851 64.5C103.235 63.9587 102.47 63.688 101.555 63.688ZM111.206 75V61.112H114.37L114.678 62.988C115.126 62.316 115.714 61.784 116.442 61.392C117.188 60.9813 118.047 60.776 119.018 60.776C121.164 60.776 122.686 61.6067 123.582 63.268C124.086 62.5027 124.758 61.896 125.598 61.448C126.456 61 127.39 60.776 128.398 60.776C130.208 60.776 131.599 61.3173 132.57 62.4C133.54 63.4827 134.026 65.0693 134.026 67.16V75H130.442V67.496C130.442 66.3013 130.208 65.3867 129.742 64.752C129.294 64.1173 128.594 63.8 127.642 63.8C126.671 63.8 125.887 64.1547 125.29 64.864C124.711 65.5733 124.422 66.5627 124.422 67.832V75H120.838V67.496C120.838 66.3013 120.604 65.3867 120.138 64.752C119.671 64.1173 118.952 63.8 117.982 63.8C117.03 63.8 116.255 64.1547 115.658 64.864C115.079 65.5733 114.79 66.5627 114.79 67.832V75H111.206ZM139.052 58.956C138.399 58.956 137.858 58.76 137.428 58.368C137.018 57.976 136.812 57.4813 136.812 56.884C136.812 56.2867 137.018 55.8013 137.428 55.428C137.858 55.036 138.399 54.84 139.052 54.84C139.706 54.84 140.238 55.036 140.648 55.428C141.078 55.8013 141.292 56.2867 141.292 56.884C141.292 57.4813 141.078 57.976 140.648 58.368C140.238 58.76 139.706 58.956 139.052 58.956ZM137.26 75V61.112H140.844V75H137.26ZM151.081 75.336C149.663 75.336 148.412 75.028 147.329 74.412C146.247 73.796 145.388 72.9373 144.753 71.836C144.137 70.7347 143.829 69.4747 143.829 68.056C143.829 66.6373 144.137 65.3773 144.753 64.276C145.388 63.1747 146.247 62.316 147.329 61.7C148.412 61.084 149.663 60.776 151.081 60.776C152.855 60.776 154.348 61.2427 155.561 62.176C156.775 63.0907 157.549 64.36 157.885 65.984H154.105C153.919 65.312 153.545 64.7893 152.985 64.416C152.444 64.024 151.8 63.828 151.053 63.828C150.064 63.828 149.224 64.2013 148.533 64.948C147.843 65.6947 147.497 66.7307 147.497 68.056C147.497 69.3813 147.843 70.4173 148.533 71.164C149.224 71.9107 150.064 72.284 151.053 72.284C151.8 72.284 152.444 72.0973 152.985 71.724C153.545 71.3507 153.919 70.8187 154.105 70.128H157.885C157.549 71.696 156.775 72.956 155.561 73.908C154.348 74.86 152.855 75.336 151.081 75.336ZM35.088 105.336C33.128 105.336 31.4107 104.907 29.936 104.048C28.48 103.189 27.332 102.004 26.492 100.492C25.6707 98.9613 25.26 97.1973 25.26 95.2C25.26 93.2027 25.6707 91.448 26.492 89.936C27.332 88.4053 28.48 87.2107 29.936 86.352C31.4107 85.4933 33.128 85.064 35.088 85.064C37.0293 85.064 38.7373 85.4933 40.212 86.352C41.6867 87.2107 42.8347 88.4053 43.656 89.936C44.4773 91.448 44.888 93.2027 44.888 95.2C44.888 97.1973 44.4773 98.9613 43.656 100.492C42.8347 102.004 41.6867 103.189 40.212 104.048C38.7373 104.907 37.0293 105.336 35.088 105.336ZM35.088 102.116C36.9547 102.116 38.4387 101.5 39.54 100.268C40.66 99.036 41.22 97.3467 41.22 95.2C41.22 93.0533 40.66 91.364 39.54 90.132C38.4387 88.9 36.9547 88.284 35.088 88.284C33.2213 88.284 31.728 88.9 30.608 90.132C29.488 91.364 28.928 93.0533 28.928 95.2C28.928 97.3467 29.488 99.036 30.608 100.268C31.728 101.5 33.2213 102.116 35.088 102.116ZM47.6604 111.16V91.112H50.8524L51.2444 93.1C51.6924 92.484 52.2804 91.9427 53.0084 91.476C53.7551 91.0093 54.7164 90.776 55.8924 90.776C57.1991 90.776 58.3658 91.0933 59.3924 91.728C60.4191 92.3627 61.2311 93.2307 61.8284 94.332C62.4258 95.4333 62.7244 96.684 62.7244 98.084C62.7244 99.484 62.4258 100.735 61.8284 101.836C61.2311 102.919 60.4191 103.777 59.3924 104.412C58.3658 105.028 57.1991 105.336 55.8924 105.336C54.8471 105.336 53.9324 105.14 53.1484 104.748C52.3644 104.356 51.7298 103.805 51.2444 103.096V111.16H47.6604ZM55.1364 102.2C56.2751 102.2 57.2178 101.817 57.9644 101.052C58.7111 100.287 59.0844 99.2973 59.0844 98.084C59.0844 96.8707 58.7111 95.872 57.9644 95.088C57.2178 94.304 56.2751 93.912 55.1364 93.912C53.9791 93.912 53.0271 94.304 52.2804 95.088C51.5524 95.8533 51.1884 96.8427 51.1884 98.056C51.1884 99.2693 51.5524 100.268 52.2804 101.052C53.0271 101.817 53.9791 102.2 55.1364 102.2ZM72.3661 105.336C70.9661 105.336 69.7247 105.037 68.6421 104.44C67.5594 103.843 66.7101 103.003 66.0941 101.92C65.4781 100.837 65.1701 99.5867 65.1701 98.168C65.1701 96.7307 65.4687 95.452 66.0661 94.332C66.6821 93.212 67.5221 92.344 68.5861 91.728C69.6687 91.0933 70.9381 90.776 72.3941 90.776C73.7567 90.776 74.9607 91.0747 76.0061 91.672C77.0514 92.2693 77.8634 93.0907 78.4421 94.136C79.0394 95.1627 79.3381 96.3107 79.3381 97.58C79.3381 97.7853 79.3287 98 79.3101 98.224C79.3101 98.448 79.3007 98.6813 79.2821 98.924H68.7261C68.8007 100.007 69.1741 100.856 69.8461 101.472C70.5367 102.088 71.3674 102.396 72.3381 102.396C73.0661 102.396 73.6727 102.237 74.1581 101.92C74.6621 101.584 75.0354 101.155 75.2781 100.632H78.9181C78.6567 101.509 78.2181 102.312 77.6021 103.04C77.0047 103.749 76.2581 104.309 75.3621 104.72C74.4847 105.131 73.4861 105.336 72.3661 105.336ZM72.3941 93.688C71.5167 93.688 70.7421 93.94 70.0701 94.444C69.3981 94.9293 68.9687 95.676 68.7821 96.684H75.6981C75.6421 95.7693 75.3061 95.0413 74.6901 94.5C74.0741 93.9587 73.3087 93.688 72.3941 93.688ZM82.0444 105V91.112H85.2364L85.5724 93.716C86.0764 92.82 86.7578 92.1107 87.6164 91.588C88.4938 91.0467 89.5204 90.776 90.6964 90.776V94.556H89.6884C88.9044 94.556 88.2044 94.6773 87.5884 94.92C86.9724 95.1627 86.4871 95.5827 86.1324 96.18C85.7964 96.7773 85.6284 97.608 85.6284 98.672V105H82.0444ZM97.626 105.336C96.4313 105.336 95.4513 105.149 94.686 104.776C93.9207 104.384 93.3513 103.871 92.978 103.236C92.6047 102.601 92.418 101.901 92.418 101.136C92.418 99.848 92.922 98.8027 93.93 98C94.938 97.1973 96.45 96.796 98.466 96.796H101.994V96.46C101.994 95.508 101.723 94.808 101.182 94.36C100.641 93.912 99.9687 93.688 99.166 93.688C98.438 93.688 97.8033 93.8653 97.262 94.22C96.7207 94.556 96.3847 95.06 96.254 95.732H92.754C92.8473 94.724 93.1833 93.8467 93.762 93.1C94.3593 92.3533 95.1247 91.784 96.058 91.392C96.9913 90.9813 98.0367 90.776 99.194 90.776C101.173 90.776 102.731 91.2707 103.87 92.26C105.009 93.2493 105.578 94.6493 105.578 96.46V105H102.526L102.19 102.76C101.779 103.507 101.201 104.123 100.454 104.608C99.726 105.093 98.7833 105.336 97.626 105.336ZM98.438 102.536C99.4647 102.536 100.258 102.2 100.818 101.528C101.397 100.856 101.761 100.025 101.91 99.036H98.858C97.906 99.036 97.2247 99.2133 96.814 99.568C96.4033 99.904 96.198 100.324 96.198 100.828C96.198 101.369 96.4033 101.789 96.814 102.088C97.2247 102.387 97.766 102.536 98.438 102.536ZM114.687 105C113.231 105 112.064 104.645 111.187 103.936C110.309 103.227 109.871 101.967 109.871 100.156V94.108H107.491V91.112H109.871L110.291 87.388H113.455V91.112H117.207V94.108H113.455V100.184C113.455 100.856 113.595 101.323 113.875 101.584C114.173 101.827 114.677 101.948 115.387 101.948H117.123V105H114.687ZM121.908 88.956C121.255 88.956 120.713 88.76 120.284 88.368C119.873 87.976 119.668 87.4813 119.668 86.884C119.668 86.2867 119.873 85.8013 120.284 85.428C120.713 85.036 121.255 84.84 121.908 84.84C122.561 84.84 123.093 85.036 123.504 85.428C123.933 85.8013 124.148 86.2867 124.148 86.884C124.148 87.4813 123.933 87.976 123.504 88.368C123.093 88.76 122.561 88.956 121.908 88.956ZM120.116 105V91.112H123.7V105H120.116ZM127.133 105V91.112H130.297L130.577 93.464C131.006 92.6427 131.622 91.9893 132.425 91.504C133.246 91.0187 134.207 90.776 135.309 90.776C137.026 90.776 138.361 91.3173 139.313 92.4C140.265 93.4827 140.741 95.0693 140.741 97.16V105H137.157V97.496C137.157 96.3013 136.914 95.3867 136.429 94.752C135.943 94.1173 135.187 93.8 134.161 93.8C133.153 93.8 132.322 94.1547 131.669 94.864C131.034 95.5733 130.717 96.5627 130.717 97.832V105H127.133ZM149.74 100.856C149.068 100.856 148.443 100.781 147.864 100.632L146.828 101.668C147.145 101.836 147.575 101.976 148.116 102.088C148.657 102.2 149.535 102.312 150.748 102.424C152.596 102.592 153.94 103.031 154.78 103.74C155.62 104.449 156.04 105.429 156.04 106.68C156.04 107.501 155.816 108.276 155.368 109.004C154.92 109.751 154.229 110.348 153.296 110.796C152.363 111.263 151.168 111.496 149.712 111.496C147.733 111.496 146.137 111.123 144.924 110.376C143.711 109.648 143.104 108.547 143.104 107.072C143.104 105.821 143.711 104.739 144.924 103.824C144.551 103.656 144.224 103.479 143.944 103.292C143.683 103.105 143.449 102.909 143.244 102.704V102.06L145.68 99.484C144.597 98.532 144.056 97.3093 144.056 95.816C144.056 94.8827 144.28 94.0333 144.728 93.268C145.195 92.5027 145.848 91.896 146.688 91.448C147.528 91 148.545 90.776 149.74 90.776C150.524 90.776 151.252 90.888 151.924 91.112H157.188V93.296L154.808 93.464C155.181 94.1733 155.368 94.9573 155.368 95.816C155.368 96.7493 155.144 97.5987 154.696 98.364C154.248 99.1293 153.595 99.736 152.736 100.184C151.896 100.632 150.897 100.856 149.74 100.856ZM149.74 98.112C150.468 98.112 151.065 97.916 151.532 97.524C152.017 97.132 152.26 96.572 152.26 95.844C152.26 95.116 152.017 94.556 151.532 94.164C151.065 93.772 150.468 93.576 149.74 93.576C148.975 93.576 148.359 93.772 147.892 94.164C147.425 94.556 147.192 95.116 147.192 95.844C147.192 96.572 147.425 97.132 147.892 97.524C148.359 97.916 148.975 98.112 149.74 98.112ZM146.38 106.708C146.38 107.399 146.697 107.912 147.332 108.248C147.985 108.603 148.779 108.78 149.712 108.78C150.608 108.78 151.336 108.593 151.896 108.22C152.456 107.865 152.736 107.38 152.736 106.764C152.736 106.26 152.549 105.84 152.176 105.504C151.821 105.168 151.103 104.963 150.02 104.888C149.255 104.832 148.545 104.748 147.892 104.636C147.351 104.935 146.959 105.261 146.716 105.616C146.492 105.971 146.38 106.335 146.38 106.708ZM32.596 135.336C31.1587 135.336 29.8893 135.093 28.788 134.608C27.6867 134.104 26.8187 133.395 26.184 132.48C25.5493 131.547 25.2227 130.417 25.204 129.092H28.984C29.0213 130.007 29.348 130.781 29.964 131.416C30.5987 132.032 31.4667 132.34 32.568 132.34C33.52 132.34 34.276 132.116 34.836 131.668C35.396 131.201 35.676 130.585 35.676 129.82C35.676 129.017 35.424 128.392 34.92 127.944C34.4347 127.496 33.7813 127.132 32.96 126.852C32.1387 126.572 31.2613 126.273 30.328 125.956C28.816 125.433 27.6587 124.761 26.856 123.94C26.072 123.119 25.68 122.027 25.68 120.664C25.6613 119.507 25.932 118.517 26.492 117.696C27.0707 116.856 27.8547 116.212 28.844 115.764C29.8333 115.297 30.972 115.064 32.26 115.064C33.5667 115.064 34.7147 115.297 35.704 115.764C36.712 116.231 37.496 116.884 38.056 117.724C38.6347 118.564 38.9427 119.563 38.98 120.72H35.144C35.1253 120.029 34.8547 119.423 34.332 118.9C33.828 118.359 33.1187 118.088 32.204 118.088C31.42 118.069 30.7573 118.265 30.216 118.676C29.6933 119.068 29.432 119.647 29.432 120.412C29.432 121.065 29.6373 121.588 30.048 121.98C30.4587 122.353 31.0187 122.671 31.728 122.932C32.4373 123.193 33.2493 123.473 34.164 123.772C35.1347 124.108 36.0213 124.5 36.824 124.948C37.6267 125.396 38.2707 125.993 38.756 126.74C39.2413 127.468 39.484 128.411 39.484 129.568C39.484 130.595 39.2227 131.547 38.7 132.424C38.1773 133.301 37.4027 134.011 36.376 134.552C35.3493 135.075 34.0893 135.336 32.596 135.336ZM43.955 141.16L47.175 134.076H46.335L40.931 121.112H44.823L48.715 130.884L52.775 121.112H56.583L47.763 141.16H43.955ZM63.6745 135.336C62.4425 135.336 61.3598 135.14 60.4265 134.748C59.4931 134.337 58.7465 133.777 58.1865 133.068C57.6265 132.359 57.2905 131.537 57.1785 130.604H60.7905C60.9025 131.145 61.2011 131.612 61.6865 132.004C62.1905 132.377 62.8345 132.564 63.6185 132.564C64.4025 132.564 64.9718 132.405 65.3265 132.088C65.6998 131.771 65.8865 131.407 65.8865 130.996C65.8865 130.399 65.6251 129.997 65.1025 129.792C64.5798 129.568 63.8518 129.353 62.9185 129.148C62.3211 129.017 61.7145 128.859 61.0985 128.672C60.4825 128.485 59.9131 128.252 59.3905 127.972C58.8865 127.673 58.4758 127.3 58.1585 126.852C57.8411 126.385 57.6825 125.816 57.6825 125.144C57.6825 123.912 58.1678 122.876 59.1385 122.036C60.1278 121.196 61.5091 120.776 63.2825 120.776C64.9251 120.776 66.2318 121.159 67.2025 121.924C68.1918 122.689 68.7798 123.744 68.9665 125.088H65.5785C65.3731 124.061 64.5985 123.548 63.2545 123.548C62.5825 123.548 62.0598 123.679 61.6865 123.94C61.3318 124.201 61.1545 124.528 61.1545 124.92C61.1545 125.331 61.4251 125.657 61.9665 125.9C62.5078 126.143 63.2265 126.367 64.1225 126.572C65.0931 126.796 65.9798 127.048 66.7825 127.328C67.6038 127.589 68.2571 127.991 68.7425 128.532C69.2278 129.055 69.4705 129.811 69.4705 130.8C69.4891 131.659 69.2651 132.433 68.7985 133.124C68.3318 133.815 67.6598 134.356 66.7825 134.748C65.9051 135.14 64.8691 135.336 63.6745 135.336ZM78.0879 135C76.6319 135 75.4652 134.645 74.5879 133.936C73.7106 133.227 73.2719 131.967 73.2719 130.156V124.108H70.8919V121.112H73.2719L73.6919 117.388H76.8559V121.112H80.6079V124.108H76.8559V130.184C76.8559 130.856 76.9959 131.323 77.2759 131.584C77.5746 131.827 78.0786 131.948 78.7879 131.948H80.5239V135H78.0879ZM89.7696 135.336C88.3696 135.336 87.1283 135.037 86.0456 134.44C84.9629 133.843 84.1136 133.003 83.4976 131.92C82.8816 130.837 82.5736 129.587 82.5736 128.168C82.5736 126.731 82.8723 125.452 83.4696 124.332C84.0856 123.212 84.9256 122.344 85.9896 121.728C87.0723 121.093 88.3416 120.776 89.7976 120.776C91.1603 120.776 92.3643 121.075 93.4096 121.672C94.4549 122.269 95.2669 123.091 95.8456 124.136C96.4429 125.163 96.7416 126.311 96.7416 127.58C96.7416 127.785 96.7323 128 96.7136 128.224C96.7136 128.448 96.7043 128.681 96.6856 128.924H86.1296C86.2043 130.007 86.5776 130.856 87.2496 131.472C87.9403 132.088 88.7709 132.396 89.7416 132.396C90.4696 132.396 91.0763 132.237 91.5616 131.92C92.0656 131.584 92.4389 131.155 92.6816 130.632H96.3216C96.0603 131.509 95.6216 132.312 95.0056 133.04C94.4083 133.749 93.6616 134.309 92.7656 134.72C91.8883 135.131 90.8896 135.336 89.7696 135.336ZM89.7976 123.688C88.9203 123.688 88.1456 123.94 87.4736 124.444C86.8016 124.929 86.3723 125.676 86.1856 126.684H93.1016C93.0456 125.769 92.7096 125.041 92.0936 124.5C91.4776 123.959 90.7123 123.688 89.7976 123.688ZM99.448 135V121.112H102.612L102.92 122.988C103.368 122.316 103.956 121.784 104.684 121.392C105.431 120.981 106.289 120.776 107.26 120.776C109.407 120.776 110.928 121.607 111.824 123.268C112.328 122.503 113 121.896 113.84 121.448C114.699 121 115.632 120.776 116.64 120.776C118.451 120.776 119.841 121.317 120.812 122.4C121.783 123.483 122.268 125.069 122.268 127.16V135H118.684V127.496C118.684 126.301 118.451 125.387 117.984 124.752C117.536 124.117 116.836 123.8 115.884 123.8C114.913 123.8 114.129 124.155 113.532 124.864C112.953 125.573 112.664 126.563 112.664 127.832V135H109.08V127.496C109.08 126.301 108.847 125.387 108.38 124.752C107.913 124.117 107.195 123.8 106.224 123.8C105.272 123.8 104.497 124.155 103.9 124.864C103.321 125.573 103.032 126.563 103.032 127.832V135H99.448Z",
    fill: "#FFB900"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10512_1552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.9481 20.8595H44.2965V27.1487H48.4062V29.561H41.9481V20.8595ZM49.7062 20.8595H56.4997V22.9272H52.0126V24.2626H56.0804V26.1579H52.0126V27.5364H56.5417V29.6041H49.7062V20.8595ZM60.9868 20.8164H63.2513L66.8578 29.561H64.3417L63.7126 28.0103H60.4417L59.8546 29.561H57.3804L60.9868 20.8164ZM63.0417 26.1149L62.1191 23.6595L61.1546 26.1149H63.0417ZM67.9901 20.8595H71.261C74.2804 20.8595 76.0417 22.6256 76.0417 25.1672C76.0417 27.6656 74.2804 29.5179 71.2191 29.5179H67.9901V20.8595ZM71.261 27.4072C72.6449 27.4072 73.6094 26.6318 73.6094 25.2103V25.1672C73.6094 23.7887 72.6868 22.9703 71.261 22.9703H70.2965V27.4072H71.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0935 41.28L47.3161 40.5477L45.429 34.6031L49.329 33.3108L48.6161 31.0277L42.4935 33.0523L45.0935 41.28ZM30.5419 26.3323L31.2548 24.0492L37.0419 25.9877L38.929 20L41.1516 20.7323L38.5516 29.0031L30.5419 26.3323ZM44.3806 41.6677L42.4935 43.0892L38.8871 38.0062L30.3323 43.52L24 48L30.4581 38.0062L33.6871 32.6646L28.7387 28.96L30.1226 27.0215L37 32.1477L30.8774 40.9354L39.4323 34.6462L44.3806 41.6677Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10512_1552)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 147,
    width: 48,
    height: 28,
    rx: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 147,
    width: 48,
    height: 28,
    rx: 14,
    fill: "url(#paint72_linear_10512_1552)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 147,
    width: 48,
    height: 28,
    rx: 14,
    fill: "url(#paint73_linear_10512_1552)"
  }))), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6979 165.899C49.3941 165.595 49.3941 165.105 49.6979 164.802L52.7124 161.776H40.8958C40.4674 161.776 40.1168 161.426 40.1168 160.999C40.1168 160.571 40.4674 160.221 40.8958 160.221H52.7124L49.6901 157.203C49.3863 156.9 49.3863 156.41 49.6901 156.106C49.9939 155.803 50.4846 155.803 50.7884 156.106L55.1505 160.454C55.4543 160.758 55.4543 161.248 55.1505 161.551L50.7962 165.899C50.4924 166.194 49.9939 166.194 49.6979 165.899Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10512_1552",
    x: 16,
    y: 139,
    width: 64,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10512_1552"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10512_1552",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10512_1552",
    x1: 266.192,
    y1: 69,
    x2: 266.192,
    y2: 179.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#D5C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C9BBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDB0B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10512_1552",
    x1: 266.192,
    y1: 164.952,
    x2: 266.192,
    y2: 197.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10512_1552",
    x1: 266.358,
    y1: 71.2656,
    x2: 266.358,
    y2: 162.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#71C6C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#4AA1AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10512_1552",
    x1: 240.855,
    y1: 69.566,
    x2: 289.01,
    y2: 81.4632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B7591"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#086998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10512_1552",
    x1: 204.597,
    y1: 104.507,
    x2: 204.597,
    y2: 120.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10512_1552",
    x1: 206.89,
    y1: 131.479,
    x2: 206.89,
    y2: 147.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10512_1552",
    x1: 206.89,
    y1: 141.677,
    x2: 206.89,
    y2: 157.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10512_1552",
    x1: 219.354,
    y1: 131.479,
    x2: 219.354,
    y2: 147.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10512_1552",
    x1: 219.354,
    y1: 141.677,
    x2: 219.354,
    y2: 157.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10512_1552",
    x1: 231.817,
    y1: 131.479,
    x2: 231.817,
    y2: 147.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_10512_1552",
    x1: 231.817,
    y1: 141.677,
    x2: 231.817,
    y2: 157.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10512_1552",
    x1: 254.479,
    y1: 131.479,
    x2: 254.479,
    y2: 147.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_10512_1552",
    x1: 254.479,
    y1: 141.677,
    x2: 254.479,
    y2: 157.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_10512_1552",
    x1: 266.942,
    y1: 131.479,
    x2: 266.942,
    y2: 147.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_10512_1552",
    x1: 266.942,
    y1: 141.677,
    x2: 266.942,
    y2: 157.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_10512_1552",
    x1: 279.406,
    y1: 131.479,
    x2: 279.406,
    y2: 147.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_10512_1552",
    x1: 279.406,
    y1: 141.677,
    x2: 279.406,
    y2: 157.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_10512_1552",
    x1: 300.934,
    y1: 132.614,
    x2: 300.934,
    y2: 148.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_10512_1552",
    x1: 300.934,
    y1: 142.811,
    x2: 300.934,
    y2: 158.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_10512_1552",
    x1: 313.398,
    y1: 132.614,
    x2: 313.398,
    y2: 148.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_10512_1552",
    x1: 313.398,
    y1: 142.811,
    x2: 313.398,
    y2: 158.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_10512_1552",
    x1: 325.861,
    y1: 132.614,
    x2: 325.861,
    y2: 148.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_10512_1552",
    x1: 325.861,
    y1: 142.811,
    x2: 325.861,
    y2: 158.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_10512_1552",
    x1: 252.185,
    y1: 103.374,
    x2: 252.185,
    y2: 119.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_10512_1552",
    x1: 299.643,
    y1: 103.374,
    x2: 299.643,
    y2: 119.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_10512_1552",
    x1: 314.503,
    y1: 71.8922,
    x2: 314.503,
    y2: 82.8629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#C5DF50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ADC74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BF49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_10512_1552",
    x1: 325.835,
    y1: 73.9777,
    x2: 325.835,
    y2: 80.8618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_10512_1552",
    x1: 266.192,
    y1: 201.7,
    x2: 266.192,
    y2: 175.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_10512_1552",
    x1: 329.811,
    y1: 176.971,
    x2: 329.811,
    y2: 169.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#C5DF50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ADC74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BF49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_10512_1552",
    x1: 378.111,
    y1: 129.857,
    x2: 378.111,
    y2: 221.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_10512_1552",
    x1: 284.048,
    y1: 112.528,
    x2: 284.048,
    y2: 145.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F99E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3875F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_10512_1552",
    x1: 294.881,
    y1: 108.985,
    x2: 293.223,
    y2: 156.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F99E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3875F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_10512_1552",
    x1: 286.529,
    y1: 108.678,
    x2: 284.929,
    y2: 154.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F99E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3875F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_10512_1552",
    x1: 282.814,
    y1: 108.206,
    x2: 281.107,
    y2: 157.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F99E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3875F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_10512_1552",
    x1: 305.862,
    y1: 130.722,
    x2: 305.862,
    y2: 196.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_10512_1552",
    x1: 344.657,
    y1: 130.508,
    x2: 344.699,
    y2: 211.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_10512_1552",
    x1: 354.636,
    y1: 77.7777,
    x2: 360.137,
    y2: 127.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC874E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C37441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#97522B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_10512_1552",
    x1: 353.006,
    y1: 138.143,
    x2: 354.109,
    y2: 114.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FA9E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F4885F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_10512_1552",
    x1: 353.111,
    y1: 135.875,
    x2: 353.941,
    y2: 117.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FA9E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F4885F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_10512_1552",
    x1: 346.826,
    y1: 84.2168,
    x2: 336.08,
    y2: 136.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB283"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAD7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA9F73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F48960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_10512_1552",
    x1: 345.861,
    y1: 90.6818,
    x2: 347.492,
    y2: 146.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB283"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F99D71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F3845C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_10512_1552",
    x1: 349.83,
    y1: 79.8688,
    x2: 355.021,
    y2: 126.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC874E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C37441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#97522B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_10512_1552",
    x1: 342.832,
    y1: 80.6637,
    x2: 347.985,
    y2: 127.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC874E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C37441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#97522B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_10512_1552",
    x1: 345.922,
    y1: 129.713,
    x2: 345.922,
    y2: 156.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0444E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C41620"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_10512_1552",
    x1: 346.643,
    y1: 131.64,
    x2: 346.643,
    y2: 154.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0444E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C41620"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_10512_1552",
    x1: 346.642,
    y1: 132.721,
    x2: 346.642,
    y2: 149.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0444E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C41620"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_10512_1552",
    x1: 197.043,
    y1: 143.233,
    x2: 197.043,
    y2: 247.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_10512_1552",
    x1: 193.941,
    y1: 108.235,
    x2: 193.941,
    y2: 163.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC874E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C37441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#97522B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_10512_1552",
    x1: 219.049,
    y1: 164.011,
    x2: 219.049,
    y2: 242.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#568998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_10512_1552",
    x1: 158.182,
    y1: 164.18,
    x2: 158.182,
    y2: 239.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#568998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_10512_1552",
    x1: 199.179,
    y1: 184.493,
    x2: 199.179,
    y2: 262.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#568998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_10512_1552",
    x1: 192.39,
    y1: 184.311,
    x2: 192.39,
    y2: 252.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#568998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_10512_1552",
    x1: 237.729,
    y1: 127.042,
    x2: 217.9,
    y2: 169.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F99E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3875F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_10512_1552",
    x1: 232.956,
    y1: 125.346,
    x2: 220.814,
    y2: 169.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F99E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3875F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_10512_1552",
    x1: 211.47,
    y1: 141.097,
    x2: 211.47,
    y2: 192.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_10512_1552",
    x1: 202.988,
    y1: 106.796,
    x2: 206.237,
    y2: 166.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC874E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C37441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#97522B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_10512_1552",
    x1: 196.194,
    y1: 141.097,
    x2: 196.194,
    y2: 192.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_10512_1552",
    x1: 196.809,
    y1: 152.158,
    x2: 196.809,
    y2: 126.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FA9E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F4885F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_10512_1552",
    x1: 196.077,
    y1: 149.056,
    x2: 196.077,
    y2: 131.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FA9E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F4885F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_10512_1552",
    x1: 194.593,
    y1: 114.403,
    x2: 207.661,
    y2: 148.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FA9E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F4885F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_10512_1552",
    x1: 185.29,
    y1: 116.118,
    x2: 195.317,
    y2: 151.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FA9E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F4885F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_10512_1552",
    x1: 189.339,
    y1: 112.292,
    x2: 191.741,
    y2: 156.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC874E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C37441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#97522B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_10512_1552",
    x1: 191.008,
    y1: 107.453,
    x2: 194.238,
    y2: 166.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC874E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C37441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#97522B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_10512_1552",
    x1: 230.03,
    y1: 142.422,
    x2: 223.911,
    y2: 142.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_10512_1552",
    x1: 226.929,
    y1: 140.836,
    x2: 225.541,
    y2: 140.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#D5C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C9BBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDB0B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_10512_1552",
    x1: 209.625,
    y1: 178.132,
    x2: 214.327,
    y2: 206.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBE96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FDB991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FAAB84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F5946E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#EE7450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_10512_1552",
    x1: 212.347,
    y1: 186.006,
    x2: 174.752,
    y2: 130.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBE96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FDB991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FAAB84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F5946E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#EE7450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_10512_1552",
    x1: 201.277,
    y1: 177.542,
    x2: 206.598,
    y2: 209.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBE96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FDB991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FAAB84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F5946E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#EE7450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_10512_1552",
    x1: 189.961,
    y1: 141.097,
    x2: 189.961,
    y2: 192.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_10512_1552",
    x1: 239.331,
    y1: 191.105,
    x2: 208.78,
    y2: 191.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_10512_1552",
    x1: 208.869,
    y1: 191.192,
    x2: 191.662,
    y2: 191.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_10512_1552",
    x1: 225.106,
    y1: 190.083,
    x2: 222.999,
    y2: 190.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_10512_1552",
    x1: 72,
    y1: 175,
    x2: 21.5788,
    y2: 169.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_10512_1552",
    x1: 48,
    y1: 107.042,
    x2: 48,
    y2: 175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDA44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5F00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10512_1552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 382,
    height: 194,
    rx: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10512_1552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 28,
    fill: "white",
    transform: "translate(24 20)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSos);
export default __webpack_public_path__ + "static/media/SOS.48093d308d8bc2218a14ead0453a0ec2.svg";
export { ForwardRef as ReactComponent };